"use strict";
exports.__esModule = true;
exports.FORM_STEPS = void 0;
var FORM_STEPS = {
    DETAILS_INVITATION: 'details.invitation',
    DETAILS_DETAILS: 'details.details',
    DETAILS_IDENTIFICATION: 'details.identification',
    FINANCIALS_CREDIT_REPORT: 'financials.credit-report',
    FINANCIALS_FILL_METHODS: 'financials.fill-methods',
    FINANCIALS_INCOME_ASSETS: 'financials.income-and-assets',
    FINANCIALS_EXPENSES_LIABILITIES: 'financials.expenses-and-liabilities',
    APPLICANT_APPROVAL: 'applicant-approval',
    GOALS: 'goals',
    OPTIONS: 'options',
    LOAN_OPTIONS: 'loan-options',
    PRE_APPROVAL: 'pre-approval'
};
exports.FORM_STEPS = FORM_STEPS;
